module.exports = __webpack_public_path__ + "static/img/CastleGroup.7c380dfc.png";